// A router keresőparam-értelmezője — MINDEN érték SZTRING marad.
//
// MIÉRT NEM a TanStack alapértelmezése: az a paramétereket JSON-ként értelmezi, tehát a `?new=1` számként (`1`), a
// `?q=123` számként, a `?x=true` logikai értékként érkezik. A route-ok `validateSearch`-e viszont mind sztringet vár
// (`z.string()`), és a lapok `=== '1'`-gyel / a `useListFilters` sztring-ellenőrzésével olvasnak — így ezek az
// értékek NÉMÁN elvesztek: a kezdőlap „Gyors műveletek" (`/tickets?new=1`, `/meetings?new=1`) nem nyitotta meg a
// létrehozó sávot (Évi #87), és egy számot tartalmazó keresés újratöltéskor eltűnt. Az URL-ben a keresőparam
// természeténél fogva szöveg; a típus-értelmezés a route sémájának dolga.

/** `?a=1&b=x` → `{ a: '1', b: 'x' }` (ismétlődő kulcsnál az utolsó érték nyer, mint az `URLSearchParams.get`-nél). */
export function parseSearchAsStrings(searchStr: string): Record<string, string> {
  const params = new URLSearchParams(searchStr.startsWith('?') ? searchStr.slice(1) : searchStr);
  const out: Record<string, string> = {};
  for (const [key, value] of params) out[key] = value;
  return out;
}

/**
 * `{ a: '1', b: undefined }` → `?a=1`. A `undefined` / `null` / üres sztring kimarad (tiszta link); a nem-sztring
 * primitív sztringgé alakul. Üres eredménynél `''` (nincs `?`).
 */
export function stringifySearchAsStrings(search: Record<string, unknown>): string {
  const params = new URLSearchParams();
  for (const [key, value] of Object.entries(search)) {
    if (value === undefined || value === null || value === '') continue;
    params.set(
      key,
      typeof value === 'string'
        ? value
        : typeof value === 'number' || typeof value === 'boolean' || typeof value === 'bigint'
          ? String(value)
          : JSON.stringify(value),
    );
  }
  const s = params.toString();
  return s === '' ? '' : `?${s}`;
}
